export const ENV = {
  SUPABASE_URL: 'https://uarctayfluygfeqfckaf.supabase.co',
  SUPABASE_ANON_KEY: 'sb_publishable_BKK60PLQU7f7FGYImdI1Kw_p7dKarvh',
  SUPABASE_EMAILS_TABLE: 'emails',
} as const
